import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=e18f74b0&"
import script from "./courseInfo.vue?vue&type=script&lang=js&"
export * from "./courseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports